module.exports = __webpack_public_path__ + "static/media/UnitedSansSmCdBd.f372c3db.woff";